
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AlertDialogType } from '@/features/common/types';

@Component
export default class AddressItem extends Vue {
  @Prop({ required: true }) dialog!: AlertDialogType;
}
